namespace SorAraBul.Administration {

    @Serenity.Decorators.registerClass()
    export class PurchasePackagesDialog extends Serenity.EntityDialog<PurchasePackagesRow, any> {
        protected getFormKey() { return PurchasePackagesForm.formKey; }
        protected getIdProperty() { return PurchasePackagesRow.idProperty; }
        protected getLocalTextPrefix() { return PurchasePackagesRow.localTextPrefix; }
        protected getNameProperty() { return PurchasePackagesRow.nameProperty; }
        protected getService() { return PurchasePackagesService.baseUrl; }
        protected getDeletePermission() { return PurchasePackagesRow.deletePermission; }
        protected getInsertPermission() { return PurchasePackagesRow.insertPermission; }
        protected getUpdatePermission() { return PurchasePackagesRow.updatePermission; }

        protected form = new PurchasePackagesForm(this.idPrefix);
    }
}
